export const BANK_WITHDRAW = "BANK_WITHDRAW";
export const OVEST_WITHDRAW = "OVEST_WITHDRAW";
export const INVESTMENT_PLAN = "INVESTMENT_PLAN";
export const INVEST_OPTIONS = "INVEST_OPTIONS";
